import { render, staticRenderFns } from "./ProposalPublic.vue?vue&type=template&id=e53e0f46&scoped=true"
import script from "./ProposalPublic.vue?vue&type=script&lang=ts"
export * from "./ProposalPublic.vue?vue&type=script&lang=ts"
import style0 from "./ProposalPublic.vue?vue&type=style&index=0&id=e53e0f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53e0f46",
  null
  
)

export default component.exports